module.exports = __webpack_public_path__ + "static/media/closeStore.4b4f0083.svg";